import classNames from "classnames";
import { useFormatter, useTranslations } from "next-intl";

import IconKikoMe from "~/components/common/icons/icon-kiko-me";
import useSubscriptions from "~/hooks/use-subscriptions";

import styles from "./data-level-bar.module.scss";
import LoyaltyProgress from "./loyalty-progress";

type Props = {
  enableSeparator?: boolean;
  showAnniversaryDate?: boolean;
  className?: string;
};

export default function DataLevelBar(props: Props) {
  const t = useTranslations();
  const formatter = useFormatter();
  const { loyaltyPoints, currentLoyaltyTier, loyaltyTiers } = useSubscriptions();
  const tierExpirationDate = currentLoyaltyTier?.ExpiresAt?.isValid
    ? formatter.dateTime(new Date(currentLoyaltyTier.ExpiresAt.toJSDate()), {
        dateStyle: "full",
      })
    : t("error.noTierExpirationDate");
  const points = loyaltyPoints ?? 0;
  const nextLevelTier = loyaltyTiers[loyaltyTiers.findIndex((tier) => tier.id === currentLoyaltyTier?.ID) + 1];
  const missingPoints = nextLevelTier ? Math.max(nextLevelTier.threshold - points, 0) : 0;

  return (
    <>
      <div className={classNames(styles.container, props.className)}>
        <div className={styles.myLevelAndMyAnniversaryWrapper}>
          <div className={styles.myLevelWrapper}>
            <p className={styles.text}>{t("generic.myLevel")}</p>
            <p className={styles.gradient}>{currentLoyaltyTier?.Name || t("loyalty.basicLevel")}</p>
          </div>
          {props.showAnniversaryDate && (
            <div className={classNames(styles.myAnniversaryWrapper, styles.desktopOnly)}>
              <p className={styles.text}>{t("generic.myAnniversaryDate")}</p>
              <p className={styles.textUppercase}>{tierExpirationDate}</p>
            </div>
          )}
          <div>
            <IconKikoMe />
          </div>
        </div>
        <LoyaltyProgress />
        {props.enableSeparator && <div className={styles.separator} />}
        <div className={styles.containerPoints}>
          <div>
            <p className={styles.textPoints}>{t("generic.yourPoints")}</p>
            <p className={styles.numberPoints}>{loyaltyPoints}</p>
          </div>
          <div className={styles.nextTierWrapper}>
            <p className={styles.textPoints}>{t("generic.nextTier")}</p>
            <p className={styles.numberPoints}>{missingPoints}</p>
          </div>
        </div>
        {props.showAnniversaryDate && (
          <>
            <div className={classNames(styles.separator, styles.mobileOnly)} />
            <div className={styles.mobileOnly}>
              <p className={styles.text}>{t("generic.myAnniversaryDate")}</p>
              <p className={styles.textUppercase}>{tierExpirationDate}</p>
            </div>
          </>
        )}
      </div>
    </>
  );
}
